import { HttpMethod, initFetch } from "../../utils/fetcher";

export const SAVE_SUCCESS_FEEDBACKS = "SAVE_SUCCESS_FEEDBACKS";
export const SAVE_FAIL_FEEDBACKS = "SAVE_FAIL_FEEDBACKS";
export const UPDATE_SUCCESS_FEEDBACKS = "UPDATE_SUCCESS_FEEDBACKS";
export const UPDATE_FAIL_FEEDBACKS = "UPDATE_FAIL_FEEDBACKS";
export const DELETE_SUCCESS_FEEDBACKS = "DELETE_SUCCESS_FEEDBACKS";
export const DELETE_FAIL_FEEDBACKS = "DELETE_FAIL_FEEDBACKS";

export function saveFeedback(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`feedbacks`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(jsonData) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.feedback);
          dispatch({
            type: SAVE_SUCCESS_FEEDBACKS,
            payload: res.feedback,
          });
        })
        .catch((err) => {
          dispatch({
            type: SAVE_FAIL_FEEDBACKS,
            error: err,
          });
        });
    });
  };
}

export function updateFeedback(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`feedbacks/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(jsonData) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.feedback);
          dispatch({
            type: UPDATE_SUCCESS_FEEDBACKS,
            payload: res.feedback,
            id: id,
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_FEEDBACKS,
            error: err,
          })
        );
    });
  };
}

export function deleteFeedback(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`feedbacks/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.feedback);
          dispatch({
            type: DELETE_SUCCESS_FEEDBACKS,
            payload: res.feedback,
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_FEEDBACKS,
            error: err,
          });
        });
    });
  };
}
